import { render } from "./PlaygroundView.vue?vue&type=template&id=4b9014a6&scoped=true"
import script from "./PlaygroundView.vue?vue&type=script&lang=js"
export * from "./PlaygroundView.vue?vue&type=script&lang=js"

import "./PlaygroundView.vue?vue&type=style&index=0&id=4b9014a6&scoped=true&lang=css"
import "./PlaygroundView.vue?vue&type=style&index=1&id=4b9014a6&scoped=true&lang=css"
import "./PlaygroundView.vue?vue&type=style&index=2&id=4b9014a6&lang=css"

import exportComponent from "../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9014a6"]])

export default __exports__